import * as Yup from 'yup';

export const signUpStepOneSchema = Yup.object({
  nameOfBusiness: Yup.string().required('Business name is required'),
  industry: Yup.string().required('Industry is required'),
  nameOfPrincipal: Yup.string().required('Name of prinicipal is required'),
  tin: Yup.string().required('TIN is required'),
});
